import React, { useEffect } from "react";
import './about.css';
import imgSrc from '../../Assets/book.jpg'
import Aos from 'aos';
import 'aos/dist/aos.css';
import { GiThreeFriends } from 'react-icons/gi';
import { FaHandHoldingHeart } from "react-icons/fa";
import { MdKeyboardDoubleArrowUp } from "react-icons/md";
import { LuMessageCircleHeart } from "react-icons/lu";

const About = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 })
  }, [])
  return (
    <section className="about section">
      <div className="secContainer">
        <h1 data-aos="fade-up" data-aos-duration="2000" className="title">
          Stuff You Will Love
        </h1>

        <div className="mainContent container grid">
          <div data-aos="fade-up" data-aos-duration="2000" className="singleItem">
             <GiThreeFriends className="imagename" />
            <h3>Meet Ups</h3>
            <p>
             Regular disability and legal network meet ups online/person.
            </p>

          </div>

          <div data-aos="fade-up" data-aos-duration="2000" className="singleItem">
            <FaHandHoldingHeart className="imagename" />
            <h3>Friendtorship</h3>
            <p>
              We help build connections in the legal professions.
            </p>
          </div>

          <div data-aos="fade-up" data-aos-duration="2000" className="singleItem">
             <MdKeyboardDoubleArrowUp className="imagename" />
            <h3>Level Up</h3>
            <p>
              Develop your CV through workshops.
            </p>
          </div>
          <div data-aos="fade-up" data-aos-duration="2000" className="singleItem">
             <LuMessageCircleHeart className="imagename" />
            <h3>Support</h3>
            <p>
              Referrals and safe space for everyone.
            </p>
          </div>
        </div>
        <h2 data-aos="fade-up" data-aos-duration="2000" className="title">
          Whether you just want to talk, Listen or Help. We are here for you!
          <br></br> <br></br><br></br><br></br>
          <button
            data-aos="fade-up"
            data-aos-duration="3000"
            className="btn"
            onClick={() =>
              window.open(
                'https://docs.google.com/forms/d/e/1FAIpQLSebvdaxwJtps6hU4PxPSEtbn9q0SR70Ujip8EZexNj1DTkTSQ/viewform?usp=header',
                'paypalPopup',
                'width=600,height=700'
              )
            }
          >
            <h3 data-aos="fade-up">Become Member</h3>
          </button>
        </h2>


        <div data-aos="fade-up" data-aos-duration="2000" className="videoCard container">
          <div className="cardContent grid">
            <div data-aos="fade-right" data-aos-duration="2000" className="cardText">
              <h2>Publications</h2>
              <p>
                This report explores key strategies for advancing diversity and inclusion across the legal profession and includes reflections on the impact of the pandemic, alongside practical developments in the field. I hope you find it a valuable and insightful read.
              </p><br></br><br></br>
              <button
                data-aos="fade-up"
                data-aos-duration="3000"
                className="btn"
                onClick={() =>
                  window.open(
                    'https://www.globelawandbusiness.com/special-reports/diversity-and-inclusion-in-the-legal-profession-second-edition',
                    'paypalPopup',
                    'width=600,height=700'
                  )
                }
              >
                <h3 data-aos="fade-up">Order Book</h3>
              </button>
            </div>

            <div data-aos="fade-left" data-aos-duration="2000" className="cardVideo">
              <img
                src={imgSrc}
                alt="Book"
                className="bookImage"
              />

            </div>

          </div>
        </div>
      </div>
    </section>

  )
}

export default About